import dayjs from 'dayjs'

/**
 * @param targetTimestamp  时间戳
 * @returns {boolean}
 */
export function isWithinLastYear(targetTimestamp: number) {
  // 将 10 位时间戳转换为毫秒级时间戳（13位）
  const millisecondsTimestamp = targetTimestamp * 1000
  // 获取当前日期
  const currentDate = new Date()

  // 计算两个日期的毫秒差
  const timeDifferenceInMs = currentDate.getTime() - millisecondsTimestamp

  // 计算年数近似值（忽略闰年影响，取一年为365天）
  const oneYearInMs = 31536000000 // 365 days * 24 hours * 60 minutes * 60 seconds * 1000 milliseconds
  const differenceInYears = timeDifferenceInMs / oneYearInMs

  // 判断是否在一年以内
  return Math.abs(differenceInYears) <= 1
}

/**
 * @description 判断当前时间是否在 某个时间段内
 * @param startTime 开始时间
 * @param endTime 结束时间
 */
export const timeRange = (startTime: string, endTime: string) => {
  const now = dayjs() // 当前时间
  if (now.isAfter(startTime) && now.isBefore(endTime)) {
    return true
  }
  return false
}
